// refers to https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js

import { PluginFunc } from 'dayjs';

import { localeConfig as enLocaleConfig } from '../config/en';
import { FormatType, FormatTypeConfig } from '../type';

export const englishFormats = enLocaleConfig.formats;

// copy from the official plugin (https://github.com/iamkun/dayjs/blob/dev/src/plugin/localizedFormat/index.js)
// A handful of TikTok custom format types like 'LL-Y', 'LT+to', 'll-Y+w' conflict with normal format which would be treated as LL(double L type) and Y(year)
const u = (formatStr: string, formats: FormatTypeConfig): string =>
  formatStr.replace(
    /(\[[^\]]+])|(ll-Y\+w|LT\+to|LLL\+to|LTS?|lts?|L{2,4}-Y|l{1,4}-Y|LL-D|ll-D|l{1,4}|L{1,4})/g,
    (_, a, b: FormatType) => a || formats[b] || englishFormats[b],
  );

const FORMAT_DEFAULT = 'YYYY-MM-DDTHH:mm:ssZ';

const plugin: PluginFunc = (_o, c, d) => {
  const proto = c.prototype;
  const oldFormat = proto.format;

  d.Ls.en.formats = englishFormats;
  proto.customFormat = function (formatStr = FORMAT_DEFAULT, replacements: Record<string, string> = {}): string {
    const { formats } = this.$locale();
    let result = u(formatStr, formats);
    // perform any replacements on the day.js format string
    for (const [key, value] of Object.entries(replacements)) {
      result = result.replace(new RegExp(`${key}(?!:)`, 'g'), value); // Prevent HH:mm:ss from being replaced
    }
    return oldFormat.call(this, result);
  };
};
export default plugin;
